// extracted by css-extract-rspack-plugin
export default {"displayWrapper":"EAdr6FwBenQFw9XR","editorWrapper":"nEWytIJDGroOxfCJ"};